import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormAccomodationsService } from '../../../../Services/FormAccomodationsService';
import { IFormAccomodations } from "../../../../Models/Forms/IFormAccomodations";
import { IFormBase } from 'src/app/Models/Forms/IFormBase';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';

@Component({
  selector: 'Accomodations',
  templateUrl: './Accomodations.component.html',
  styleUrls: ['./Accomodations.component.css']
})

export class FormAccomodationsComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  lookupStrategies: ILookupBase[];
  lookupOrganization: ILookupBase[];
  lookupInstruction: ILookupBase[];
  lookupAdaptation: ILookupBase[];
  lookupTesting: ILookupBase[];
  lookupGeneral: ILookupBase[];
  selectedStrategyIds: any[];
  selectedOrganizationIds: any[];
  selectedInstructionIds: any[];
  selectedAdaptationIds: any[];
  selectedTestingIds: any[];
  selectedGeneralIds: any[];

  _lookupService: LookupService;
  //_lookupTypeEnum: LookupTypeEnum;
  accomodationsDB: any = [];
  //public showSpinner: boolean = false;
  //checkbox binds boolean type only.
  chkNames: any = [];
  notetaking: boolean;
  shortinstructions: boolean;
  accesscomputer: boolean;
  highlighttextbooks: boolean;
  scribe: boolean;
  calculator: boolean;
  seating: boolean;
  planner: boolean;
  breaks: boolean;
  cues: boolean;
  supervision: boolean;
  extratime: boolean;
  behavior: boolean;
  offer: boolean;
  communication: boolean;
  onetask: boolean;
  repeated: boolean;
  understanding: boolean;
  extendtime: boolean;
  separatestudy: boolean;
  essential: boolean;
  projects: boolean;
  grade: boolean;
  books: boolean;
  adapted: boolean;
  reduced: boolean;
  modified: boolean;
  adaptlargeprint: boolean;
  markers: boolean;
  visual: boolean;
  largeprint: boolean;
  notes: boolean;
  parts: boolean;
  sessions: boolean;
  wordprocessor: boolean;
  readaloudexcept: boolean;
  flexibletime: boolean;
  braille: boolean;
  openbook: boolean;
  alternative: boolean;
  shortened: boolean;
  readaloudentire: boolean;
  testcalculator: boolean;
  dictations: boolean;
  _reportService: any;
  reportParamArray: IReportParameter[];

  constructor
    (
      private globals: Globals,
      private _formAccomodationsService: FormAccomodationsService,
      iepService: IepService,
      @Inject('BASE_URL') baseUrl: string,
      public router: Router,
      lookupService: LookupService,
      reportService: ReportService, ) {
    super(reportService);
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
    this.chkNames = ['notetaking', 'accesscomputer', 'highlighttextbooks', 'scribe', 'calculator', 'seating', 'planner', 'breaks',
      'cues', 'supervision', 'extratime', 'behavior', 'offer', 'communication', 'onetask', 'repeated', 'understanding',
      'extendtime', 'separatestudy', 'essential', 'projects', 'grade', 'books', 'adapted', 'reduced', 'modified',
      'adaptlargeprint', 'markers', 'visual', 'largeprint', 'notes', 'parts', 'sessions', 'wordprocessor', 'readaloudexcept',
      'flexibletime', 'braille', 'openbook', 'alternative', 'shortened', 'readaloudentire', 'testcalculator', 'dictations'];
  }

  ngOnInit(): void {
    this.LoadFormAccomodationsDetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadFormAccomodationsDetails(): void {
    this._formAccomodationsService.getFormAccomodations(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormAccomodations) => {
        this.accomodationsDB = res,
          this.accomodationsDB.filedate = new Date(this.accomodationsDB.filedate);
        this.SetSelectedListboxValues();
        this.bindCheckboxOptions()
      },
        err => console.error(err)
      );
  }

  SetSelectedListboxValues() {
    if (this.accomodationsDB.adaptionIds != null) {
      this.selectedAdaptationIds = this.accomodationsDB.adaptionIds.map(String);
    }
    if (this.accomodationsDB.generalIds != null) {
      this.selectedGeneralIds = this.accomodationsDB.generalIds.map(String);
    }
    if (this.accomodationsDB.instructionIds != null) {
      this.selectedInstructionIds = this.accomodationsDB.instructionIds.map(String);
    }
    if (this.accomodationsDB.organizationIds != null) {
      this.selectedOrganizationIds = this.accomodationsDB.organizationIds.map(String);
    }
    if (this.accomodationsDB.strategyIds != null) {
      this.selectedStrategyIds = this.accomodationsDB.strategyIds.map(String);
    }
    if (this.accomodationsDB.testingIds != null) {
      this.selectedTestingIds = this.accomodationsDB.testingIds.map(String);
    }
  }

  SaveSelectedListboxValues() {
    this.accomodationsDB.adaptionIds = this.selectedAdaptationIds;
    this.accomodationsDB.generalIds = this.selectedGeneralIds;
    this.accomodationsDB.instructionIds = this.selectedInstructionIds;
    this.accomodationsDB.organizationIds = this.selectedOrganizationIds;
    this.accomodationsDB.strategyIds = this.selectedStrategyIds;
    this.accomodationsDB.testingIds = this.selectedTestingIds;
  }

  bindCheckboxOptions() {
    for (var item of this.chkNames) {
      if (this.accomodationsDB[item] == 'Y') {
        this[item] = true
      }
      else {
        this[item] = false
      }
    }
  }

  updateCheckboxOptions() {
    for (var item of this.chkNames) {
      if (this[item] == true) {
        this.accomodationsDB[item] = 'Y'
      }
      else {
        this.accomodationsDB[item] = 'N'
      }
    }
  }
  LoadLookupValues() {
    //STRATEGIES
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupClassroomAndTestingAccommodationsList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ClassroomAndTestingAccommodations] + '&category=STRATEGIES')
      .subscribe((res: ILookupBase[]) => {
        this.lookupStrategies = res
      },
        err => console.error(err)
      );
    //ORGANIZATION
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupClassroomAndTestingAccommodationsList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ClassroomAndTestingAccommodations] + '&category=ORGANIZATION')
      .subscribe((res: ILookupBase[]) => {
        this.lookupOrganization = res
      },
        err => console.error(err)
      );
    //INSTRUCTION
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupClassroomAndTestingAccommodationsList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ClassroomAndTestingAccommodations] + '&category=INSTRUCTION')
      .subscribe((res: ILookupBase[]) => {
        this.lookupInstruction = res
      },
        err => console.error(err)
      );
    //ADAPTATION
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupClassroomAndTestingAccommodationsList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ClassroomAndTestingAccommodations] + '&category=ADAPTATION')
      .subscribe((res: ILookupBase[]) => {
        this.lookupAdaptation = res
      },
        err => console.error(err)
      );
    //TESTING
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupClassroomAndTestingAccommodationsList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ClassroomAndTestingAccommodations] + '&category=TESTING')
      .subscribe((res: ILookupBase[]) => {
        this.lookupTesting = res
      },
        err => console.error(err)
      );
    //General
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupClassroomAndTestingAccommodationsList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ClassroomAndTestingAccommodations] + '&category=General')
      .subscribe((res: ILookupBase[]) => {
        this.lookupGeneral = res
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the Accomodations
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.updateCheckboxOptions();
    this.SaveSelectedListboxValues();

    //update values
    this._formAccomodationsService.insertUpdateFormAccomodations(this.accomodationsDB)
      .subscribe((res: IFormAccomodations) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormAccomodationsDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormAccomodationsDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.accomodationsDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.accomodationsDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.accomodationsDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.accomodationsDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
